import React, { useEffect, useState } from 'react';
import { Container, Card, Badge, Button } from 'react-bootstrap';
import { List } from 'rsuite';
import LegacyUserIcon from "@rsuite/icons/legacy/User";
import LegacyBuildingIcon from "@rsuite/icons/legacy/Building";
import LegacyPlusIcon from "@rsuite/icons/legacy/Plus";
import seal from '../../../images/LAPELS-LOLA-Logo.png';
import AuthService from "../../../services/auth.service";

const accountIcon = (account) => {
    if (account.roles?.includes("Firm")) {
        return <LegacyBuildingIcon style={{ fontSize: "1.4em" }} className="me-2 text-muted" />;
    }
    return <LegacyUserIcon style={{ fontSize: "1.4em" }} className="me-2 text-muted" />;
};

function SwitchAccountPage() {
    const [accounts, setAccounts] = useState([]);

    const refresh = () => {
        setAccounts(AuthService.getCachedAccounts());
    };

    useEffect(() => {
        refresh();
    }, []);

    // Always a hard reload (never client-side navigate) - Main.js only re-derives
    // which app shell (Individual/Firm/Staff) to render on a fresh page load, so a
    // soft navigate here would leave a stale shell mounted against the newly active
    // account's token.
    const switchTo = (account) => {
        AuthService.switchToAccount(account.account);
    };

    const goHome = () => {
        window.location.href = "/";
    };

    const signOutOf = (account, e) => {
        e.stopPropagation();
        AuthService.removeCachedAccount(account.nameIdentifier);
        refresh();
    };

    const addAccount = () => {
        window.location.href = "/login?addAccount=1";
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: '#2976a3',
                    color: 'white',
                    padding: '10px',
                    height: '90px',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <span role="button" onClick={goHome} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <img src={seal} alt="Lapels Seal" style={{ width: '60px' }} />
                    <b style={{ fontSize: '40px', marginLeft: '10px' }}>LOLA</b>
                </span>
            </div>
            <Container fluid className="mainContent">
                <Card style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <Card.Title><center><h3>Switch Accounts</h3></center></Card.Title>
                    <Card.Body>
                        <List hover bordered>
                            {accounts.map((account) => (
                                <List.Item
                                    key={account.nameIdentifier}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => switchTo(account)}
                                >
                                    <div className="d-flex justify-content-between align-items-center">
                                        <span className="d-flex align-items-center">
                                            {accountIcon(account)}
                                            <span>
                                                <div>
                                                    <strong>{account.formattedName || account.userName}</strong>
                                                    {account.isCurrent && <Badge bg="success" className="ms-2">Current</Badge>}
                                                </div>
                                                <div className="text-muted text-small">{account.lolaNumber || ' '}</div>
                                            </span>
                                        </span>
                                        <Button
                                            variant="link"
                                            size="sm"
                                            className="text-danger signOutLink"
                                            onClick={(e) => signOutOf(account, e)}
                                        >
                                            Sign Out
                                        </Button>
                                    </div>
                                </List.Item>
                            ))}
                            <List.Item style={{ cursor: 'pointer' }} onClick={addAccount}>
                                <span className="d-flex align-items-center text-primary">
                                    <LegacyPlusIcon style={{ fontSize: "1.4em" }} className="me-2" />
                                    <strong>Add Account</strong>
                                </span>
                            </List.Item>
                        </List>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
}

export default SwitchAccountPage;
